import React from 'react';

import {useSignup} from './useSignup.hooks';
import {BRAND_NAME} from '../../../config';

import {SignupSuccess} from './SignupSuccess';
import {PhoneNumberMask} from '../../_common/MaskedInput';
import Modal from "react-modal";

const isLong = false;

function Error({message, dataTestId = 'error-alert'}) {
  return (
    <div style={{background: '#ffebe7', padding: 0.5, marginBottom: 10}}>
      <p style={{color: 'tomato', textAlign: 'center'}} data-testid={dataTestId}>
        {message}
      </p>
    </div>
  );
}

export const Signup = ({goToLoginPage}) => {
  const {formData, onChange, isLoading, error, handleSubmit, isDone, clearIsDone, isExistingUser, clearExistingUser} = useSignup();

  if (isDone) {
    return (
      <SignupSuccess clearIsDone={clearIsDone} goToLoginPage={goToLoginPage}/>
    );
  }

  return (
    <>
      <form className="tw-space-y-6" onSubmit={handleSubmit}>
        
        {isLong && (
          <>
          <div>
            <label htmlFor="firstName" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">First Name</label>
            <div className="tw-mt-2">
              <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                    type="text" name="firstName" autoComplete="off" required
                    value={formData.firstName} onChange={onChange}/>
            </div>
          </div>

          <div>
            <label htmlFor="lastName" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Last Name</label>
            <div className="tw-mt-2">
              <input className="form-control form-control-solid placeholder-no-fix form-group login-input"
                    type="text" name="lastName" autoComplete="off" required
                    value={formData.lastName} onChange={onChange}/>
            </div>
          </div>
          </>
          )}
    
        
          <div>
            <label htmlFor="email" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Email address</label>
            <div className="tw-mt-2">
              <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                    type="email" 
                    name="email"
                    autoComplete="off" 
                    required
                    value={formData.email} 
                    onChange={onChange}/>
            </div>
          </div>

          {isLong && (
          <>
          <div>
            <label htmlFor="phone" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Phone Number</label>
            <div className="tw-mt-2">
              <PhoneNumberMask inputClass="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                              name="phone" value={formData.phone}
                              handleChange={onChange} required/>
            </div>
          </div>
          </>
          )}

          <div>
            <label htmlFor="companyName" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Company Name</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                   type="text" name="companyName" autoComplete="off" placeholder="" required
                   value={formData.companyName} onChange={onChange}/>
            </div>
          </div>

          {isLong && (
          <>
          <div>
            <label htmlFor="licenseNumber" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">License Number</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                   type="text" name="licenseNumber" autoComplete="off" required
                   value={formData.licenseNumber} onChange={onChange}/>
            </div>
          </div>
          </>
          )}
        
          <div>
            <label htmlFor="password" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Password</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                   type="password" name="password" autoComplete="off" required
                   aria-required="true" aria-invalid="false" value={formData.password} onChange={onChange}/>
            </div>
          </div>

          <div>
            <label htmlFor="confirmPassword" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Retype Password</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                   type="password" name="confirmPassword" autoComplete="off" required
                   aria-required="true" aria-invalid="false" value={formData.confirmPassword} onChange={onChange}/>
            </div>
          </div>
        
          {isLong && (
          <>

          <h4>Company Address</h4>
          
          <div>
            <label htmlFor="companyAddressStreet" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Street Address</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                    type="text" name="companyAddressStreet" autoComplete="off" required
                    value={formData.companyAddressStreet} onChange={onChange}/>
            </div>
          </div>

          <div>
            <label htmlFor="companyAddressCity" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">City</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                    type="text" name="companyAddressCity" autoComplete="off" required
                    value={formData.companyAddressCity} onChange={onChange}/>
            </div>
          </div>
          
          
          <div>
            <label htmlFor="companyAddressState" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">State</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
                    type="text" name="companyAddressState" autoComplete="off" required
                    value={formData.companyAddressState} onChange={onChange}/>
            </div>
          </div>

          <div>
            <label htmlFor="companyAddressZip" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Zip code</label>
            <div className="tw-mt-2">
            <input className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6" type="text"
                    name="companyAddressZip" autoComplete="off" required
                    value={formData.companyAddressZip} onChange={onChange}/>
            </div>
          </div>
          
          <label htmlFor="source" style={{fontWeight: 'bold'}}>How did you hear about us?</label>
          <select className="form-control" name="source" value={formData.source} onChange={onChange} required style={{border: 'none', height: 'auto'}}>
            <option value="">Select One</option>
            <option value="current-user">Current User</option>
            <option value="search">Internet Search</option>
            <option value="email">Email</option>
            <option value="web-ad">Web Advertisement</option>
          </select>
          </>
          )}


        <div className="">
          <label className="mt-checkbox mt-checkbox-outline">
            <input type="checkbox" name="hasConsented" checked={formData.hasConsented}
                    data-testid="consent-checkbox"
                    onChange={(e) =>
                      onChange({target: {name: 'hasConsented', value: !formData.hasConsented}})
                    }/>
            {' '}I agree to {BRAND_NAME}'s{' '}
            <a target="_blank" rel="noopener noreferrer" href="/app/terms-and-conditions" data-testid="terms-link" className="tw-font-semibold tw-text-blue-500 tw-no-underline hover:tw-text-blue-400 hover:tw-no-underline">
              Terms &amp; Conditions{' '}
            </a>{' '}
            and{' '}
            <a target="_blank" rel="noopener noreferrer" href="/app/privacy-policy" data-testid="privacy-link" className="tw-font-semibold tw-text-blue-500 tw-no-underline hover:tw-text-blue-400 hover:tw-no-underline">
              Privacy Policy
            </a>
            <span/>
          </label>
        </div>



        <div className="" style={{position: 'relative'}}>
          {error && <Error message={error}/>}
        </div>

        <button
            className="tw-flex tw-w-full tw-rounded-md tw-bg-blue-500 tw-justify-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-xs hover:tw-bg-blue-400 focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-500"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? 'Signing Up...' : 'Sign Up'}
        </button>

      </form>
      <Modal
          isOpen={isExistingUser}
          className="Modal__Bootstrap modal-dialog"
          ariaHideApp={false}
      >
          <div className="modal-content">
              <div className="modal-header">
                  <h4 className="modal-title tw-text-2xl" style={{float: 'left'}}>Welcome Back</h4>
                  <button type="button" className="close" onClick={clearExistingUser}
                      ref={(node) => node?.style.setProperty("background-image", "none", "important")}
                      style={{fontSize: 24, float: 'right', width: 'auto', textIndent: 0}}>
                      <span aria-hidden="true">&times;</span>
                      <span className="sr-only">Close</span>
                  </button>
              </div>
              <div className="modal-body">
                  <p className='tw-mb-5'>Welcome back! We found an existing account with this email address. You can <a className='tw-text-primary tw-font-bold tw-underline' href="/login">log in here</a> or 
                  {' '}
                  <a className='tw-text-primary tw-font-bold tw-underline' href='/forgot-password'>click here if you've forgotten your password.</a></p>
                  <p>If you would like to create a new account, please provide a different email address.</p>
              </div>
              <div className="modal-footer">
                  <button type="button" 
                      className='btn btn-primary tw-bg-primary'
                      onClick={clearExistingUser}>OK</button>
              </div>
          </div>
      </Modal>
    </>
  );
};
